import * as Sentry from '@sentry/react';

let initialized = false;

/**
 * Initialize Sentry for the browser. No-op unless REACT_APP_SENTRY_DSN is set —
 * that way local dev and test don't talk to Sentry but production flips on via env.
 */
export function initSentry(): void {
  if (initialized) return;
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_RELEASE,
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE) || 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event) {
      // Strip Authorization header if somehow captured in a fetch breadcrumb.
      if (event.request?.headers) {
        const headers = event.request.headers as Record<string, string>;
        delete headers.authorization;
        delete headers.Authorization;
        delete headers.cookie;
      }
      return event;
    },
  });

  initialized = true;
}

/**
 * Attach the signed-in user to every Sentry event. Omit PII beyond email
 * + role — enough to triage a crash to a real person, nothing more.
 */
export function setSentryUser(u: { id: string; email?: string; role?: string } | null): void {
  if (!initialized) return;
  if (u) {
    Sentry.setUser({ id: u.id, email: u.email, role: u.role } as any);
  } else {
    Sentry.setUser(null);
  }
}

export { Sentry };
